var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCell3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.3 50",
    style: {
      enableBackground: "new 0 0 37.3 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF3F3F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,43.2c-0.3-2.1,0.3-3.8,1.9-5.2c0.1-0.1,0.2-0.2,0.2-0.4c0-3.2,0-6.5,0-9.7c0-1.9,1-3.2,2.9-3.6 c0,0,0,0,0.1,0c0.1,0,0.3,0,0.4,0c0-4.5,0-9.1,0-13.6c0-2-1.2-3.1-3.2-3.1c-0.9,0-1.7,0-2.6,0c0-0.2,0-0.3,0-0.5c0-1.3,0-2.5,0-3.8 c0-0.9-0.6-1.5-1.5-1.5c-2.9,0-5.7,0-8.6,0c-0.9,0-1.5,0.6-1.5,1.5c0,1.3,0,2.5,0,3.8c0,0.2,0,0.3,0,0.5c-1,0-1.9,0-2.8,0 c-1.8,0-3,1.2-3,3c0,1,0,2.1,0,3.1c0,10.4,0,20.9,0,31.3c0,1.1,0.3,2,1.2,2.6C5.2,47.9,5.6,48,6,48.2c6.2,0,12.3,0,18.5,0 c0.5-0.1,0.8-0.3,1.1-0.5C23.6,47.2,21.8,45.5,21.5,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,42.3c0,0.8,0.6,1.4,1.4,1.4c0-0.9,0-1.9,0-2.8C26.1,40.9,25.5,41.5,25.5,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.9,27.9c0,3.4,0,6.8,0,10.2c0,0.3-0.1,0.6-0.4,0.8c-1.3,1-1.9,2.2-1.7,3.8c0.2,2,1.9,3.5,3.8,3.7 c0.2-0.4,0.2-0.9,0.3-1.4c-0.1,0-0.1,0-0.2,0c-1.2-0.1-2.3-1.1-2.5-2.2c-0.2-1.3,0.5-2.8,2.1-3.3c0-0.1,0-0.2,0-0.3 c0-2.9,0-5.7,0-8.6c0-0.1,0-0.2,0-0.4c0.1-0.3,0.3-0.5,0.6-0.5c0-1.4,0-2.7,0-4.1c-0.2,0-0.5,0-0.7,0.2 C25.3,26.3,24.9,27,24.9,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,37.6c0-3.2,0-6.5,0-9.7c0-1.7-1-3-2.5-3.4c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0c0,0.5,0,0.9,0,1.4 c1.1,0,2.1,0.8,2.1,1.9c0,1.7,0,3.5,0,5.2c0,0,0,0,0,0c0,1.7,0,3.4,0,5.2c0,0.3,0.1,0.6,0.4,0.8c1.4,1.1,2,2.5,1.6,4.2 c-0.4,1.7-1.4,2.8-3.1,3.2c-0.4,0.1-0.8,0.1-1.3,0.1c-0.2,0.5-0.5,0.9-1,1.3c0.8,0.2,1.6,0.2,2.4,0c2.2-0.5,3.6-1.9,4.2-4 c0.6-2.2-0.1-4-1.7-5.6C30.4,37.9,30.3,37.8,30.3,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,28.4c0.3,0,0.7,0,1,0c0.3,0,0.6,0,1,0c0.2,0,0.4-0.1,0.5-0.1c0.3-0.1,0.3-0.5,0.3-0.7 c-0.1-0.3-0.3-0.5-0.7-0.5c-0.7,0-1.3,0-2,0c-0.5,0-0.8,0.3-0.8,0.7C31.7,28.1,32,28.4,32.5,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,31.2c0.3,0,0.7,0,1,0c0.3,0,0.7,0,1,0c0.4,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.7-0.8-0.7c-0.7,0-1.3,0-2,0 c-0.5,0-0.8,0.3-0.8,0.7C31.7,30.9,32,31.2,32.5,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,32.6c-0.3,0-0.7,0-1,0c-0.3,0-0.7,0-1,0c-0.5,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.7c0.7,0,1.3,0,2,0 c0.4,0,0.7-0.3,0.7-0.7C35.2,32.9,34.9,32.6,34.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,35.3c-0.7,0-1.3,0-2,0c-0.5,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1,0c0.3,0,0.7,0,1,0 c0.5,0,0.8-0.3,0.8-0.7C35.2,35.6,34.9,35.3,34.4,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.6,43c0.2-0.6,0.1-1.3-0.1-1.9c-0.4-0.8-1-1.4-1.9-1.6c0-1,0-2.1,0-3.1c0-2,0-4,0-5.9 c0-0.4-0.3-0.7-0.6-0.7c0,0-0.1,0-0.1,0c0,3.7,0,7.4,0,11c0,0,0,0,0,0c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0 c0,0.3,0,0.6,0,0.9c0,0.2,0,0.3,0,0.4C28.2,45,29.3,44.2,29.6,43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell3);
export default __webpack_public_path__ + "static/media/cell3.520e0b251a5b4a8df193d0a157ddf614.svg";
export { ForwardRef as ReactComponent };